module.exports = __webpack_public_path__ + "img/en.942f27f1.svg";